
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const fenrir: Operator = {
	id: 'fenrir',
	name: 'Fenrir',
	role: 'Defender',
	org: 'UNAFFILIATED',
	squad: 'REDHAMMER',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 3
	},
	meta: {
		gender: 'm',
		country: 'se',
		season: 'Y8S2',
		height: 176,
		weight: 74,
		price: {
			renown: 20000,
			r6credits: 480
		}
	},
	bio: {
		real_name: 'Emil Svensson',
		birthplace: 'Uppsala, Sweden'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73.002 73.002h204v204h-204z" style="fill:#5f51bf"></path><path d="M208.002 77.002c-2-20-26-8-24-26 1-7-4-12-13-14 29-4 11 18 29 20 16 1 25 11 25 23zm-68-8 1 12c-7-5-4-6-16-7-8-2-10-12-10-13 2 4 7 8 10 8zm-45 57c-6-12-17-1-23-6 10 1 17-18 31 3z" style="fill:#fff"></path><path d="M45.002 305.002v-67l-21 7 16-26 24-60-8 1 25-24h-8l32-15-7-12 33-8-3-21 13 2-4-45 36 31-3-27 22 33 59 9 18 17h68l3 11v8l-30 29v-10h-4l-10 9 2-9-25 7-16 19-3 14q-1.86 8.13 1 11l12 12 5-2-1 10-5 7v9l-19 2-47-38 19 22 1 16 14 13h-9l31 32-11-1 23 34z"></path><path d="m239.002 143.002-5 12h-6c-17-3-15-20-29-16-62 16-26-38-71-34-67 7-24-39-65-45 28-4 29 32 55 32 25-1 35-20 48 17 18 39 18-3 68 25q13-3 19 2z" style="fill:#fff"></path><path d="m222.002 173.002 1 3c-18-3-16-18-45-12-50 16-24-34-63-37 42-4 27 36 56 25 35-12 36 10 51 9z" style="fill:#fff"></path><path d="m142.002 46.002 22 24-4 14-11-9zm-58 101 25-11-6 10h10l-3 10 18-5-2 13 9-4 2 8 27 8-30 2-18 5 7-11-20 1 9-12-16-1 4-11z" style="fill:#5f51bf"></path><path d="m171.002 92.002 40 2 7-5h18l1 1c12-1 15 7 17 10h10l-5 8h22c10-2 30-7 35-3l12 11 2 5-7 8-64 2 10-3 8-8-20-2-5-2-3 4h-26l-16-13zm62 1 15 6 3 11-17 2-8-8z" style="fill-rule:evenodd;clip-rule:evenodd;fill:#5f51bf"></path><path d="M254.002 139.002h18l-4 3-17 19-2 13-12-17 5-11zm-29 22 5-1 8 10 4 10 15 16-10 7-12-11-10-22zm33 36 8 8v1h-9l1-2zm-223 40 10-11 7-21v25zm55-32-1 16h6l-3 11h12l2 14 17-8v22l1 10-11-13-13 4-7-20-12 3 6-17-9-1zm81 30 23 10 3-6 10 5-6-20 8 1-6-27 9 11 3 18 9 8h-5l-6-2 1 19-12-4-4 6zm59 15 19 19-15-3 5-2z" style="fill:#5f51bf"></path><path d="M320.002 104.002h14l4 8v6m-39 20 5-1-6.6 7.6zm-44 69-6-1v-2l7.9-5.6v4.6z" style="fill:#fff"></path><circle cx="236.667" cy="103.667" r="5" style="fill:#fff"></circle></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-fenrir'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
